import { AvailabilityBlockState } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { createHandler } from '@mews/std';
import { TextKey } from '@mews-commander/enums';
import { Tag, TagVariant } from '@optimus-web/core';
import { useAvailabilityBlock } from '../../../modules/availabilityBlock/utils/useAvailabilityBlock';

interface AvailabilityBlockStateTagProps {
    availabilityBlockId: string;
}

const getTagVariantFromAvailabilityBlockState = createHandler<AvailabilityBlockState, TagVariant>(
    {
        [AvailabilityBlockState.Confirmed]: 'denim',
        [AvailabilityBlockState.Inquired]: 'basicSubtle',
        [AvailabilityBlockState.Optional]: 'basicBold',
        [AvailabilityBlockState.Canceled]: 'basicSubtle',
    },
    'basicBold'
);

const getTextAvailabilityBlockState = createHandler<AvailabilityBlockState, Mews.TextKey>(
    {
        [AvailabilityBlockState.Confirmed]: TextKey.AvailabilityBlockStateConfirmed,
        [AvailabilityBlockState.Inquired]: TextKey.AvailabilityBlockStateInquired,
        [AvailabilityBlockState.Optional]: TextKey.AvailabilityBlockStateOptional,
        [AvailabilityBlockState.Canceled]: TextKey.AvailabilityBlockStateCanceled,
    },
    TextKey.AvailabilityBlockStateConfirmed
);

const AvailabilityBlockStateTag: React.FC<AvailabilityBlockStateTagProps> = ({ availabilityBlockId }) => {
    const availabilityBlock = useAvailabilityBlock(availabilityBlockId);
    const blockState = availabilityBlock?.state;

    const textKey = getTextAvailabilityBlockState(blockState);
    const variant = getTagVariantFromAvailabilityBlockState(blockState);

    return (
        <Tag variant={variant}>
            <LocalizedText textKey={textKey} />
        </Tag>
    );
};

export default AvailabilityBlockStateTag;
